export const IDB_NAME = 'VN_POS_DB'
export const IDB_VERSION = 1
export const IDB_ITEMS_STORE = 'items'
export const IDB_PERSIST_NAME = 'VN_PERSIST_STORE'
export const IDB_PERSIST_VERSION = 2
export const PERSIST_HYDRATE_TIMEOUT = 20_000
